


















































import Vue from 'vue';
import store from '@/store';
import _ from 'lodash';
import Draggable from 'vuedraggable';
import PropertyListing from './property-listing.vue';
import ButtonToggle from '@/components/common/button-toggle.vue';
import PropertyResultsCardTile from '@/components/property/property-results-card-tile.vue';
import PropertyResultsCardList from '@/components/property/property-results-card-list.vue';
import { Component, Prop, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Properties from "@/store/property/Properties";
import FavouritesModule from "@/store/Favourites";
import { ChoiceScore } from "@/api/model/ViewpointChoiceScore";
import { Choice } from "@/api/model/Choice";

const propertiesModule = getModule(Properties)
const favouritesModule = getModule(FavouritesModule);
@Component({
  components: {
    'draggable': Draggable,
    'button-toggle': ButtonToggle,
    'property-listing': PropertyListing,
    'property-results-card-tile': PropertyResultsCardTile,
    'property-results-card-list': PropertyResultsCardList,
  }
})
export default class PropertyResultsCards extends Vue {

  @Prop({
    type: Boolean,
    default: false,
  })
  favouritesFlag!: boolean

  @Prop({
    type: String,
    default: 'rank',
  })
  changeSortProp!: string

  @Prop({
    type: String,
    default: 'tile',
  })
  changeViewProp!: string

  @Prop()
  choices!: { [id: string]: Choice };

  @Prop()
  choicesScores!: ChoiceScore[];

  @Prop()
  favourites!: string[];

  dialog = true
  erroredGet = false
  erroredPost = false
  factorGroupName = 'Lifestyle'
  changeRank = false

  get viewClass(): string {
    return (this.changeViewProp == 'tile' ? 'tile-view' : 'list-view');
  }

  dragStart() {
    // this.dragging = true;
  }

  dragEnd() {
    getModule(FavouritesModule).updateFavouriteOrder(this.favourites)
  }

  formatNumber(value: number, digits: number = 0) {
    if (digits < 0) digits = 0;
    var formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits,
    });
    return Number(formatter.format(value));
  }


}

